import {
  CreateCronFilterInterface,
  CronFilterInterface,
  CronSettingsRepositoryInterface,
} from '@/services/QA/cron-settings/interfaces';
import { AxiosInstance } from 'axios';

export default class CronSettingsRepository implements CronSettingsRepositoryInterface {
  private readonly axios: AxiosInstance;

  constructor(
    axios: AxiosInstance,
  ) {
    this.axios = axios;
  }

  public async createCronFilter(settings: CreateCronFilterInterface): Promise<void> {
    await this.axios.post('/ticket-controller/cron', settings);
  }

  public async getCronFilters(): Promise<CronFilterInterface[]> {
    const res = await this.axios.get('/ticket-controller/cron');

    return res.data;
  }

  public async editCronFilter(id: number, settings: CreateCronFilterInterface): Promise<void> {
    await this.axios.patch(`/ticket-controller/cron/${id}`, { value: settings.value });
  }

  public async getFilterById(filterId: number): Promise<CronFilterInterface> {
    const res = await this.axios.get(`/ticket-controller/cron/${filterId}`);

    return res.data;
  }

  public async deleteFilter(id: number): Promise<void> {
    await this.axios.delete(`/ticket-controller/cron/${id}`);
  }
}
